import React, { ReactNode } from 'react';
import { ButtonStyled } from './Button.styled';
import { ButtonProps } from '@mui/material';

interface IButton extends ButtonProps {
  name: string;
  style?: { [key: string]: string | number };
  styleVariant?: 'dark' | 'light' | 'outline' | 'outline-dark';
  radius?: string;
  className?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}

export default function Button({
  name,
  style,
  styleVariant,
  radius,
  className,
  type = 'button',
  iconLeft,
  iconRight,
  children,
  ...props
}: IButton) {
  return (
    <ButtonStyled {...{ radius, style, styleVariant, type, className, ...props }}>
      {!!iconLeft && iconLeft}
      {children}
      {!!iconRight && iconRight}
    </ButtonStyled>
  );
}
